import {AfterViewInit, ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, signal} from '@angular/core';
import {AccountCommentsEditorComponent} from '../components/account-comments-editor/account-comments-editor.component';
import {AccountData} from '../../api-client-kt/src';

@Component({
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        AccountCommentsEditorComponent
    ],
    template: `
        <div class="layout-vbox" style="gap: 10px">
            <div>Cell comments go here</div>
            <app-account-comments-editor [account]="account()" [segment]="" field="account" (onCommentsUpdated)="dumpComments($event)">
            </app-account-comments-editor>
            <div class="toolbar-horizontal">
                <fluent-button (click)="dumpComments(account())">Dump</fluent-button>
            </div>
        </div>
    `,
    styles: `
        app-account-comments-editor {
            width: 350px;
            border: 1px solid #ccc;
        }
    `
})
export class TestAccountCommentsEditorComponent implements AfterViewInit {

    protected readonly account = signal(account1);

    constructor() {
    }

    ngAfterViewInit(): void {
    }

    protected dumpComments(account: AccountData) {
        const comments = account.metadataComments;
        console.log('Comments:', comments);
    }
}

const account1: AccountData = {
    "id": "ac1cf001-9a6e-1316-819a-6ea5a6ca33bd",
    "version": 3,
    "editedAt": new Date("2025-11-10T16:51:10.985Z"),
    "editedBy": "python-service",
    "status": "Open",
    "country": "GB",
    "crmSubmissionId": "SUB-26090-Q5G1P2",
    "expiringSubmissionUuid": "02fdffd0-4071-ef11-a670-6045bd88385a",
    "renewalSubmissionUuid": "54ad5a60-307f-f011-b4cc-7ced8d0f12e8",
    "uwbId": "GB-PRP-AB51390-2024",
    "uwy": 2024,
    "account": "ROLLS-ROYCE HOLDINGS PLC",
    "broker": "MARSH UK LIMITED",
    "underwriter": "Ankeet PATEL",
    "renewalUnderwriter": "Will Howell",
    "product": "All Risks",
    "inceptionDate": new Date("2024-12-01T00:00:00.000Z"),
    "expiryDate": new Date("2025-11-30T00:00:00.000Z"),
    "expiringCurrency": "GBP",
    "gwp": 52500,
    "gnwpEur": 63233.97,
    "multinationalFlag": true,
    "crmRenewalId": "SUB-73418-L5L1S1",
    "uwbRenewalId": "GB-PRP-AB51390-2025",
    "renewalStatus": "Active",
    "renewalGwp": 52500,
    "renewalGnwp": 67119.21,
    "renewalCurrency": "GBP",
    "renewalInceptionDate": new Date("2025-12-01T00:00:00.000Z"),
    "renewalExpiryDate": new Date("2026-11-30T00:00:00.000Z"),
    "expiringShare": 0.075,
    "expiringExposure": 25877227356.41,
    "expiringDeductible": 0,
    "expiringLimit": 1000000000,
    "renewalShare": 0.075,
    "repricingFacilityErc": 0.79,
    "manualErc": 0,
    "scoreAts": 1.0671043675472642,
    "hazardGrade": 2,
    "aalOnPremium": 0.5538000000000001,
    "oarr": 83.09,
    "leadFollow": "Follow",
    "renewalRunningDays": 364,
    "calculatedPilStatus": "Protect",
    "finalPilStatus": "Protect",
    "targetRateChange": 0.0021323147462670444,
    "riskFactors": 1,
    "asIfPremiumExpired": 63233.97,
    "effectiveRateChange": undefined,
    "retentionRate": 0,
    "bucketWeight": 0.0005541223983689116,
    "portfolioWeight": 0.0003739983074135921,
    "gwpEur": 63233.96567299006,
    "prevPilStatus": "Protect",
    "keyAccount": false,
    "renewableFlag": true,
    "metadataChecks": [],
    "aptp": 1.8028,
    "adjustedVolatility": 0,
    "createdBy": "python-service",
    "createdAt": new Date("2025-11-10T16:42:21.258Z"),
    "updatedBy": "alexw@3n5yh8.onmicrosoft.com",
    "updatedAt": new Date("2026-02-03T17:30:42.116Z"),
    "renewalGwpEur": 63233.96567299006,
    "renewalGnwpEur": 80842.16802168022,
    "pricing_adequacy": 1.8028,
    "pricing_adequacy_adjusted": 1.8028,
    "adequacy_percentile": 0.539905849922428,
    "adequacy_wpercentile": null,
    "adequacy_score": 1.0671043675472642,
    "adequacy_score_rescaled": 1.0671043675472642,
    "new_target_rate_change": 0.0021323147462670444,
    "expiring_gnwp_earned_in_uwy": 5211.590934065934,
    "expiring_gnwp_earned_in_uwy_renewal": null,
    "aalOnPremium_percentile": 0.03747870528109032,
    "aalOnPremium_wpercentile": 0.007027257240204435,
    "aptp_percentile": 0.6354344122657581,
    "aptp_wpercentile": 0.15885860306643954,
    "adjustedVolatility_percentile": 0.2694444444444445,
    "adjustedVolatility_wpercentile": 0.06736111111111112,
    "historicalIlr_percentile": null,
    "historicalIlr_wpercentile": null,
    "oarr_percentile": 0.9813084112149533,
    "oarr_wpercentile": 0.3066588785046729,
    metadataComments: [
        {
            "id": "83b2a741-62b9-420d-b125-de470ea3cea0",
            "field": "broker",
            "createdBy": "AlexW@3n5yh8.onmicrosoft.com",
            "createdAt": new Date("2026-03-04T13:05:55.388Z"),
            "content": "First message, preset"
        }
    ]
} as any;

const account2 = {
    "id": "ac1cf001-9a6e-1316-819a-6ea5a6f3358a",
    "version": 4,
    "editedAt": "2025-11-12T16:46:42.573Z",
    "editedBy": "python-service",
    "status": "Open",
    "country": "GB",
    "crmSubmissionId": "SUB-34925-K1D7V3",
    "expiringSubmissionUuid": "23d992b6-6ea6-ef11-b8e8-7c1e5260a3d5",
    "renewalSubmissionUuid": "37293aaf-119f-f011-bbd3-7c1e525d45af",
    "uwbId": "GB-PRP-AD34063-2025",
    "policyId": "25-DF00378A",
    "uwy": 2025,
    "account": "GENERALI REAL ESTATE S.P.A.",
    "broker": "MARSH LIMITED",
    "underwriter": "Katy Hobden",
    "renewalUnderwriter": "Katy Hobden",
    "product": "All Risks",
    "inceptionDate": "2025-01-01T00:00:00.000Z",
    "expiryDate": "2025-12-31T00:00:00.000Z",
    "expiringCurrency": "GBP",
    "gwp": 95131.32,
    "gnwpEur": 114581.54,
    "multinationalFlag": true,
    "crmRenewalId": "SUB-82243-C4B2N4",
    "uwbRenewalId": "GB-PRP-AD34063-2026",
    "renewalStatus": "Active",
    "renewalGwp": 95131,
    "renewalGnwp": 65243.65,
    "renewalCurrency": "GBP",
    "renewalInceptionDate": "2026-01-01T00:00:00.000Z",
    "renewalExpiryDate": "2026-12-31T00:00:00.000Z",
    "expiringShare": 0.4,
    "expiringExposure": 871710409,
    "expiringDeductible": 500,
    "expiringLimit": 871710409,
    "renewalShare": 0.4,
    "repricingFacilityErc": 0,
    "scoreAts": 0.9325121694423368,
    "hazardGrade": 1,
    "aalOnPremium": 0.1606,
    "leadFollow": "Lead",
    "renewalRunningDays": 364,
    "calculatedPilStatus": "Improve",
    "finalPilStatus": "Improve",
    "targetRateChange": 0.1,
    "riskFactors": 1,
    "asIfPremiumExpired": 114581.54,
    "effectiveRateChange": null,
    "retentionRate": 0,
    "bucketWeight": 0.0025247703614061172,
    "portfolioWeight": 0.0006776943155845314,
    "gwpEur": 114581.53568202349,
    "keyAccount": false,
    "renewableFlag": true,
    "metadataChecks": [],
    "aptp": 0.7763,
    "largeFrequency": 0.000989521302031532,
    "largeLossMargin": -0.000259899021767386,
    "adjustedVolatility": 0.001249420323798918,
    "createdBy": "python-service",
    "createdAt": "2025-11-10T16:42:21.299Z",
    "updatedBy": "alexw@3n5yh8.onmicrosoft.com",
    "updatedAt": "2026-02-03T17:30:42.119Z",
    "row": 90,
    "renewalGwpEur": 114581.150255947,
    "renewalGnwpEur": 78583.13760915387,
    "pricing_adequacy": 0.7763,
    "pricing_adequacy_adjusted": 0.7763,
    "adequacy_percentile": 0.19703910197947672,
    "adequacy_wpercentile": null,
    "adequacy_score": 0.9325121694423368,
    "adequacy_score_rescaled": 0.9325121694423368,
    "new_target_rate_change": 0.1,
    "expiring_gnwp_earned_in_uwy": 114581.54,
    "expiring_gnwp_earned_in_uwy_renewal": null,
    "aalOnPremium_percentile": 0.3918228279386712,
    "aalOnPremium_wpercentile": 0.10686077125600121,
    "aptp_percentile": 0.12947189097103917,
    "aptp_wpercentile": 0.047080687625832424,
    "adjustedVolatility_percentile": 0.11851851851851847,
    "adjustedVolatility_wpercentile": 0.04309764309764308,
    "historicalIlr_percentile": null,
    "historicalIlr_wpercentile": null,
    "oarr_percentile": null,
    "oarr_wpercentile": null
};
